import React from "react";
import { Routes, Route } from "react-router-dom";

import EmptyLayout from "../layout/EmptyLayout";
import LoginPage from '../../client/js/component/dump/forms/login/LoginPage';
import RestorePasswordPage from "../../client/js/component/dump/forms/login/RestorePasswordPage";
import ResetPasswordPage from "../../client/js/component/dump/forms/login/ResetPasswordPage";
import CreatePasswordPage from "../../client/js/component/dump/forms/login/CreatePasswordPage";
import NotFoundComponent from "../../client/js/component/dump/NotFoundComponent";
import GeotabCredentialsContainer from "../../client/js/component/smart/geotab/GeotabCredentialsContainer";
import WebfleetCredentialsContainer from "../../client/js/component/smart/geotab/WebfleetCredentialsContainer";
import IturanCredentialsContainer from "../../client/js/component/smart/geotab/IturanCredentialsContainer";
import WexLinkCredentialsContainer from "../../client/js/component/smart/geotab/WexLinkCredentialsContainer";
import ConfirmationPage from "../../client/js/component/dump/forms/login/ConfirmationPage";
import PatternsPartnerRedirectContainer from "./deep-links/PatternsPartnerRedirectContainer";

import LiveVideoLayout from '../layout/LiveVideoLayout';
import RequireWebfleetAuth from "./guards/RequireWebfleetAuth";
import RequireAuth from "./guards/RequireAuth";
import EulaAgreementPage from "../../client/js/component/smart/forms/login/EulaAgreementPage";
import LiveVideoContainer from "../../client/js/component/smart/menuComponentsContainer/LiveVideoContainer";
import LiveVideoErrorContainer from "../../client/js/component/smart/menuComponentsContainer/LiveVideoErrorContainer";
import AdvancedPlayerOpenClip from "../../client/js/component/smart/permalinks/AdvancedPlayerOpenClip";

import Layout from "../layout/Layout";
import RoleStartPage from "./RoleStartPage";
import FleetManagerDashboard from "../../client/js/pages/dashboard/FleetManagerDashboard/FleetManagerDashboard";
import SupportContainer from "../../client/js/component/smart/menuComponentsContainer/SupportContainer";
import LegalNotice from "../../client/js/component/dump/menuComponents/LegalNotice";
import ManageVehicles from "../../client/js/component/smart/menuComponentsContainer/ManageVehicles";
import EditAssetContainer from "../../client/js/component/smart/menuComponentsContainer/EditAssetContainer";
import InstallationReportAssetContainer
    from "../../client/js/component/smart/menuComponentsContainer/InstallationReportAssetContainer";
import ZonesPage from "../../client/js/pages/zones";
import ManageAssetsGroups from "../../client/js/component/dump/menuComponents/ManageAssetsGroups";
import AddGroupContainer from "../../client/js/component/smart/menuComponentsContainer/AddGroupContainer";
import EditGroupContainer from "../../client/js/component/smart/menuComponentsContainer/EditGroupContainer";
import ManageUsers from "../../client/js/component/dump/menuComponents/ManageUsers";
import ManageAssetsUserEditContainer from "../../client/js/component/smart/menuComponentsContainer/ManageAssetsUserEditContainer";
import AccountSettings from "../../client/js/component/smart/account/AccountSettings";
import RequireRole from "./guards/RequireRole";
import FleetAdminServerStatsContainer from "../../client/js/component/smart/menuComponentsContainer/FleetAdminServerStatsContainer";
import AdminSingleActions from "../../client/js/component/smart/menuComponentsContainer/AdminSingleActions";
import ReleasesPage from "../../client/js/pages/releases/ReleasesPage";
import ChangePasswordContainer from "../../client/js/component/smart/menuComponentsContainer/ChangePasswordContainer";
import FleetAdminModemContainer from "../../client/js/pages/modems/FleetAdminModemContainer";
import AccountFleetSettings from "../../client/js/component/smart/account/AccountFleetSettings";
import PartnerWhitelabelSettings from "../../client/js/pages/partners/whitelabel/PartnerWhitelabelSettings";
import CompanyContainer from "../../client/js/component/smart/menuComponentsContainer/CompanyContainer";
import CompanyEditContainerTabs from "../../client/js/pages/companies/CompanyEditContainerTabs";
import PartnerContainer from "../../client/js/component/smart/menuComponentsContainer/PartnerContainer";
import PartnerEditContainer from "../../client/js/component/smart/menuComponentsContainer/PartnerEditContainer";
import PartnerAddContainer from "../../client/js/component/smart/menuComponentsContainer/PartnerAddContainer";
import Events from "../../client/js/component/dump/menuComponents/Events";
import AccountUserContainer from "../../client/js/component/smart/account/AccountUserContainer";
import Reports from "../../client/js/component/dump/menuComponents/Reports";
import Firmware from "../../client/js/pages/firmware/Firmware";
import ManageDriversPage from "../../client/js/pages/drivers/ManageDriversPage";
import ManageBilling from "../../client/js/pages/billing/ManageBilling";
import PatternsEventContainer from "./deep-links/PatternsEventContainer";
import PatternsEventIdContainer from "./deep-links/PatternsEventIdContainer";
import PatternsDriverIdContainer from "./deep-links/PatternsDriverIdContainer";
import PatternsDeviceInstalledReport from "./deep-links/PatternsDeviceInstalledReport";
import PatternsDeviceContainer from "./deep-links/PatternsDeviceContainer";

const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<EmptyLayout />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/restore-password" element={<RestorePasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/create-password" element={<CreatePasswordPage />} />
                <Route path="/not-found" element={<NotFoundComponent />} />
                <Route path="/mygeotab/credentials/:provider/:companyHash" element={<GeotabCredentialsContainer />} />
                <Route path="/webfleet/credentials/:companyHash" element={<WebfleetCredentialsContainer />} />
                <Route path="/ituran/credentials/:companyHash" element={<IturanCredentialsContainer />} />
                <Route path="/wexlink/credentials/:companyHash" element={<WexLinkCredentialsContainer />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
                <Route path="/permalink/partner/:page_type/:company_id" element={<PatternsPartnerRedirectContainer />} />
                <Route path="/permalink/partner/:page_type/:company_id/:id" element={<PatternsPartnerRedirectContainer />} />
            </Route>
            <Route element={<RequireWebfleetAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/live/stream/:deviceId" element={<LiveVideoContainer />} />
                    <Route path="/live/stream/:deviceId/error" element={<LiveVideoErrorContainer />} />
                </Route>
            </Route>
            <Route element={<RequireAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/live/video/:deviceId" element={<LiveVideoContainer />} />
                    <Route path="/live/video/:deviceId/error" element={<LiveVideoErrorContainer />} />
                </Route>
            </Route>
            <Route element={<RequireAuth />}>
                <Route path="/event/video/:eventId" element={<AdvancedPlayerOpenClip />} />
            </Route>
            <Route element={<RequireAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/eula-agreement" element={<EulaAgreementPage />} />
                </Route>
                <Route path="/" element={<Layout />}>
                    <Route index element={<RoleStartPage />} />
                    <Route element={<RequireRole roles={['fleet_manager', 'system_admin', 'customer_service']} />}>
                        <Route path="/dashboard" element={<FleetManagerDashboard />} />
                    </Route>
                    <Route path="support" element={<SupportContainer />} />
                    <Route path="legal-notice" element={<LegalNotice />} />
                    <Route path="managevehicles" element={<ManageVehicles />} />
                    <Route path="managevehicles/edit" element={<EditAssetContainer />} />
                    <Route path="managevehicles/edit/:id" element={<EditAssetContainer />} />
                    <Route path="managevehicles/installation/report" element={<InstallationReportAssetContainer />} />
                    <Route path="zones" element={<ZonesPage />} />
                    <Route path="managegroups" element={<ManageAssetsGroups />} />
                    <Route path="managegroups/add" element={<AddGroupContainer />} />
                    <Route path="managegroups/edit" element={<EditGroupContainer />} />
                    <Route path="manageusers" element={<ManageUsers />} />
                    <Route path="manageusers/edit" element={<ManageAssetsUserEditContainer />} />
                    <Route path="/account/settings" element={<AccountSettings />} />
                    <Route element={<RequireRole roles={['system_admin']} />}>
                        <Route path="/fleet-admin/server-stats" element={<FleetAdminServerStatsContainer />} />
                        <Route path="/single-actions" element={<AdminSingleActions />} />
                        <Route path="/fleet-admin/releases" element={<ReleasesPage />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner']} />}>
                        <Route path="manageusers/change-password" element={<ChangePasswordContainer />} />
                        <Route path="/fleet-admin/modem" element={<FleetAdminModemContainer />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'fleet_manager']} />}>
                        <Route path="/account/fleet-settings" element={<AccountFleetSettings />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin']} />}>
                        <Route path="/partner/whitelabel" element={<PartnerWhitelabelSettings />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'sales_demo']} />}>
                        <Route path="/company" element={<CompanyContainer />} />
                        <Route path="/company/edit" element={<CompanyEditContainerTabs />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service']} />}>
                        <Route path="/partner" element={<PartnerContainer />} />
                        <Route path="/partner/edit" element={<PartnerEditContainer />} />
                        <Route path="/partner/add" element={<PartnerAddContainer />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'group_manager', 'partner', 'user', 'partner_view', 'sales_demo', 'storage_manager', 'storage_user', 'custom_user', 'custom_partner']} />}>
                        <Route path="/event" element={<Events />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'group_manager', 'partner', 'user', 'partner_view', 'sales_demo', 'storage_manager', 'storage_user', 'custom_user', 'custom_partner']} />}>
                        <Route path="/account" element={<AccountUserContainer />} />
                        <Route path="reports" element={<Reports />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'partner_view']} />}>
                        <Route path="/fleet-admin/firmware" element={<Firmware />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'fleet_maintainer', 'partner', 'partner_view', 'sales_demo', 'custom_user', 'custom_partner']} />}>
                        <Route path="managedrivers" element={<ManageDriversPage />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service']} />}>
                        <Route path="/billing" element={<ManageBilling />} />
                    </Route>
                    <Route path="/patterns/event/:device_id/:timestamp" element={<PatternsEventContainer />} />
                    <Route path="/patterns/events/:event_id/:event_type" element={<PatternsEventIdContainer />} />
                    <Route path="/patterns/drivers/:driver_trip_id" element={<PatternsDriverIdContainer />} />
                    <Route path="/patterns/device/installed/report/:report_id" element={<PatternsDeviceInstalledReport />} />
                    <Route path="/patterns/:type/device/:device_id/:timestamp" element={<PatternsDeviceContainer />} />
                    <Route path="/patterns/:type/device/:device_id" element={<PatternsDeviceContainer />} />
                </Route>
            </Route>
        </Routes>
    )
}

export default AppRoutes;
